import { NgModule, type Provider } from '@angular/core';
import { NgMedipassModule } from '@principle-theorem/ng-medipass';
import { NgPatientModule } from '@principle-theorem/ng-patient/ng-patient';
import {
  ACCOUNT_CREDIT_TRANSACTION_PROVIDER,
  NgPrincipleSharedModule,
} from '@principle-theorem/ng-principle-shared';
import { NgSharedModule } from '@principle-theorem/ng-shared';
import { NgStripeModule } from '@principle-theorem/ng-stripe';
import { NgTyroModule } from '@principle-theorem/ng-tyro';
import { CoreModule } from 'ng-flex-layout';
import { AccountCreditTransactionProvider } from './account-credit/account-credit-transaction-provider.service';
import { AccountCreditTransactionComponent } from './account-credit/account-credit-transaction.component';
import { CashTransactionProvider } from './cash/cash-transaction-provider.service';
import { SelectClaimProviderComponent } from './claim-estimate/select-claim-provider/select-claim-provider.component';
import { AmendDiscountTransactionDialogComponent } from './discount/amend-discount-transaction-dialog/amend-discount-transaction-dialog.component';
import { DiscountTransactionProvider } from './discount/discount-transaction-provider.service';
import { DiscountTransactionComponent } from './discount/discount-transaction.component';
import { GeneralProviderActionsService } from './general-provider-actions.service';
import { HicapsConnectTransactionModule } from './hicaps-connect/hicaps-connect-transaction.module';
import { AmendManualTransactionDialogComponent } from './manual/amend-manual-transaction-dialog/amend-manual-transaction-dialog.component';
import { ManualExtendedDataComponent } from './manual/manual-extended-data/manual-extended-data.component';
import { ManualTransactionProvider } from './manual/manual-transaction-provider.service';
import { ManualTransactionComponent } from './manual/manual-transaction.component';
import { MedipassTransactionModule } from './medipass/medipass-transaction.module';
import { StripeTransactionProvider } from './stripe/stripe-transaction-provider.service';
import { StripeTransactionComponent } from './stripe/stripe-transaction.component';
import { TransactionActionFactoryService } from './transaction-action-factory.service';
import { TransactionComponentsModule } from './transaction-components/transaction-components.module';
import { TransactionProviders } from './transaction-providers.service';
import { TyroTransactionModule } from './tyro/tyro-transaction.module';
// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  AccClaimService,
  AccInvoiceService,
} from '@principle-theorem/ng-funding-requests';
import { AccTransactionProvider } from './acc/acc-transaction-provider.service';
import { AccountCreditTransferTransactionProvider } from './account-credit-transfer/account-credit-transfer-transaction-provider.service';
import { AmendAccountCreditTransactionDialogComponent } from './account-credit/amend-account-credit-transaction-dialog/amend-account-credit-transaction-dialog.component';
import { MohTransactionProvider } from './moh/moh-transaction-provider.service';
import { SelectSmartpayTerminalComponent } from './smartpay/select-smartpay-terminal/select-smartpay-terminal.component';
import { SelectSmartpayTerminalService } from './smartpay/select-smartpay-terminal/select-smartpay-terminal.service';
import { SmartpayCardPurchaseTransactionProvider } from './smartpay/smartpay-card-purchase-transaction-provider.service';
import { SmartpayExtendedDataComponent } from './smartpay/smartpay-extended-data/smartpay-extended-data.component';
import { SmartpayPurchaseBuilder } from './smartpay/smartpay-purchase-builder.service';
import { SmartpayQRPurchaseTransactionProvider } from './smartpay/smartpay-qr-purchase-transaction-provider.service';
import { SmartpayService } from './smartpay/smartpay.service';
import { PractitionerAllocationBreakdownComponent } from './transaction-components/practitioner-allocation-breakdown/practitioner-allocation-breakdown.component';
import { SelectVerifoneTerminalComponent } from './verifone/select-verifone-terminal/select-verifone-terminal.component';
import { SelectVerifoneTerminalService } from './verifone/select-verifone-terminal/select-verifone-terminal.service';
import { VerifoneCardPurchaseTransactionProvider } from './verifone/verifone-card-purchase-transaction-provider.service';
import { VerifonePurchaseBuilder } from './verifone/verifone-purchase-builder.service';
import { VerifoneTransactionDialogService } from './verifone/verifone-transaction-dialog/verifone-transaction-dialog.service';
import { VerifoneService } from './verifone/verifone.service';

export const ACCOUNT_CREDIT_TRANSACTION_PROVIDER_PROVIDER: Provider = {
  provide: ACCOUNT_CREDIT_TRANSACTION_PROVIDER,
  useExisting: AccountCreditTransactionProvider,
};

@NgModule({
  imports: [
    NgPrincipleSharedModule,
    CoreModule,
    NgMedipassModule,
    NgStripeModule,
    NgTyroModule,
    NgPatientModule,
    TransactionComponentsModule,
    TyroTransactionModule,
    MedipassTransactionModule,
    NgSharedModule,
    HicapsConnectTransactionModule,
    PractitionerAllocationBreakdownComponent,
  ],
  providers: [
    ManualTransactionProvider,
    CashTransactionProvider,
    DiscountTransactionProvider,
    AccountCreditTransactionProvider,
    ACCOUNT_CREDIT_TRANSACTION_PROVIDER_PROVIDER,
    AccountCreditTransferTransactionProvider,
    StripeTransactionProvider,
    MohTransactionProvider,
    AccTransactionProvider,
    AccClaimService,
    AccInvoiceService,
    TransactionProviders,
    GeneralProviderActionsService,
    TransactionActionFactoryService,
    SmartpayCardPurchaseTransactionProvider,
    SmartpayQRPurchaseTransactionProvider,
    SelectSmartpayTerminalService,
    SmartpayService,
    SmartpayPurchaseBuilder,
    VerifoneCardPurchaseTransactionProvider,
    SelectVerifoneTerminalService,
    VerifoneService,
    VerifonePurchaseBuilder,
    VerifoneTransactionDialogService,
  ],
  declarations: [
    ManualTransactionComponent,
    StripeTransactionComponent,
    DiscountTransactionComponent,
    AccountCreditTransactionComponent,
    ManualExtendedDataComponent,
    AmendManualTransactionDialogComponent,
    AmendDiscountTransactionDialogComponent,
    SelectClaimProviderComponent,
    SelectSmartpayTerminalComponent,
    SmartpayExtendedDataComponent,
    AmendAccountCreditTransactionDialogComponent,
    SelectVerifoneTerminalComponent,
  ],
  exports: [TransactionComponentsModule],
})
export class TransactionProvidersModule {}
